import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { closeSearch } from "../helpers"

import "./styles/index.css"

init({  
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: ".activateNosto #Search-In-Modal",
    contentCssSelector: ".activateNosto #MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpPath: '/search',
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    persistentSearchCache: true,
    compressUrlParameters: true,
    fallback: true,
    categoryCssSelector: '.activateNosto #nostoTargetPLP',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
                fields: [
                    "productId", "url", "categories",
                    "name", "tags1",
                    "imageUrl", "alternateImageUrls",
                    "brand", "availability",
                    "price", "listPrice",
                    "customFields.key", "customFields.value",
                    "skus.name", "skus.price", "skus.listPrice",
                    "skus.availability", "skus.id", "skus.imageUrl",
                    "skus.customFields.key", "skus.customFields.value"
                ],
            }
        }
    },
}).then(() => {
    document.querySelector('.search-modal__form.small-hide .search__button.field__button')?.addEventListener('click', () => {
        document.querySelector('.search-modal__form.small-hide .field .search__input')?.focus();
    });

    document.querySelectorAll('.search__input').forEach(inputEl => {
        inputEl.addEventListener('keydown', (e) => {
            if(e.key === 'Escape' || e.key === 'Enter') {
                closeSearch()
            }
        })
    })
})